export const ConfirmationPopup = ({ open, message, subMessage, onClose, onConfirm, loading }) => {
  if (!open) return null;
  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
      <div className="modal-dialog confirmation-modal-width sessions-modal">
        <div className="modal-content">
          <div className="modal-header border-0">
            <button type="button" className="btn-close font-12" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="d-flex flex-column align-items-center justify-content-center">
              <img src="/Images/cancel-popup-icon.svg" alt="completed-icon" className="mb-3" />
              <p className="font-14 semibold-text text-center mb-0">{message}</p>
              <p className="font-12 medium-text grey-text text-center mt-1">{subMessage}</p>
            </div>
          </div>
          <div className="modal-footer border-0">
            <div className="col-md-12 d-flex justify-content-center">
              <button className="btn hive-btn-secondary me-3" onClick={onClose} disabled={loading}>No</button>
              <button className="btn hive-negative-btn" onClick={onConfirm} disabled={loading}>
                {loading ? "Processing..." : "Yes"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};